import { Component, OnInit } from '@angular/core';
import { CashMovementService } from '../../services/cash-movement.service';
import { UserService } from '../../../common/services/user.service';

import * as _ from 'lodash/lodash';
import * as moment from 'moment/moment';

import { Observable } from 'rxjs/Observable';
declare let alasql;

@Component({
  selector: 'app-list-cash-movement',
  templateUrl: './list-cash-movement.component.html',
  styleUrls: ['./list-cash-movement.component.css'],
  providers:[CashMovementService,UserService]
})
export class ListCashMovementComponent implements OnInit {
    p: number = 1;
    totalItems: number = 0;
    cashMovements: any = [];  
  
    filters:any = {
    };
    users: any = [];
    fromDate:any;
    untilDate:any;
    showExportButton:boolean = true;
    exportParams:any ={};
    role:number = 3;
  
    constructor(private cashMovementService: CashMovementService, private userService:UserService) { }
  
    ngOnInit() {
        this.getCashMovements();
        this.getUsers();
        try{
          this.role = JSON.parse(localStorage.getItem('user')).role;  
        }catch(e){
        }
    }


    getUsers(){
      return new Promise((resolve, reject) => {
          this.userService.query({})
              .subscribe((users) => {
                  this.users = users;
                  this.users.unshift({id:null, username:"Ninguno"})
                  resolve();
              });
      });
    }
  
    getCashMovements(){
      if (this.filters.createdBy == null){
          delete this.filters.createdBy;
      }
      if (this.filters.type == 0){
          delete this.filters.type;
      }
      if (!(this.filters.amount > 0)){
          delete this.filters.amount;
      }
      var params = {
        where: _.cloneDeep(this.filters),
        sort: 'id DESC',
        skip: (this.p-1)*10,
        limit: 10
      };
      if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
        params.where.createdAt = params.where.createdAt? params.where.createdAt:{};
        params.where.createdAt[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
      if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
        params.where.createdAt = params.where.createdAt? params.where.createdAt:{};
        params.where.createdAt["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
      }
      this.exportParams = params;
      this.cashMovementService.query(params)
      .subscribe((cashMovements) => {
        this.cashMovementService.count({})
        .subscribe((count) => {
          this.totalItems = count.count;
        });
        this.cashMovements = cashMovements;
      });
    }

    delete(id){
      var r = confirm("¿Esta seguro de borrar este Trasvase?");
      if (r == true) {
        var params = {
          where: _.cloneDeep(this.filters),
          sort: 'id DESC',
          skip: (this.p-1)*10,
          limit: 10
        };
        this.cashMovementService.delete(id)
        .subscribe(() => {
          this.cashMovementService.query(params)
          .subscribe(() => {
            this.getCashMovements();
          });
        });
      }
    }

    exportCashMovementsToExcel(){
      this.showExportButton = false;
      var options = {   
          fieldSeparator: ';',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          showTitle: false,
          useBom: false,   
          bookType:'xlsx' ,  
          cellStyles:true,
      };    
      let report = [
              {
                  field1:"Tipo",
                  field2:"Desde",
                  field3:"Hasta",
                  field4:"Total",
                  field5:"Usuario",
                  field6:"Fecha"
                  
              }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableCahsMovementsRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100;
        observableCahsMovementsRequest.push(this.cashMovementService.query(this.exportParams));
      }
      Observable.forkJoin(observableCahsMovementsRequest)
          .subscribe(data => {
            let p:any = data;
            let cashMovements = p.flat(); 
  
            cashMovements.forEach(cashMovement =>{
                  var row = {
                      field1:cashMovement.type == 1?'Ingreso':'Gasto',
                      field2:cashMovement.from_shop?cashMovement.from_shop.name:'Banco',
                      field3:cashMovement.to_shop?cashMovement.to_shop.name:'Banco',
                      field4:cashMovement.amount,
                      field5:cashMovement.createdBy?cashMovement.createdBy.username:'',
                      field6:cashMovement.createdAt?moment(cashMovement.createdAt).format("DD-MM-YYYY HH:mm"):''
                  }
                  report.push(row);
                });
                var mystyle = {   
                    headers:true,       
                    columns:    
                        [{columnid:'field1',width:100,title: ''},   
                        {columnid:'field2',width:100,title: ''},
                        {columnid:'field3',width:100,title: 'LISTADO DE TRASVASES'},
                        {columnid:'field4',width:100,title: ''},
                        {columnid:'field5',width:100,title: ''},
                        {columnid:'field6',width:100,title: ''},
                        
                        ],
                    /*header*/
                  
                    column: {  
                        style:{
                            Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",  
                                WrapText:1
                                
                            },
                            Font:{
                                Bold:"1",
                                Color:"#000000",
                                Size:10
                            },
                            
                            Interior:{
                                Color:"#7CEECE",
                                Pattern:"Solid"
                            }
                        }},
                  cells: {    
                        0:{
                            0:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid",
                                        },
                                Alignment:{
                                  Horizontal:"Center",
                                  Vertical:"Center",
                                  WrapText: 1,
                                    },  
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                                },                        
                                }  
                            },
                            1:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                            },  
                                Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },            
                                    }
                            },
                            2:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        }, 
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            }                
                                    }
                                },
                            3:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },            
                                      
                                    }
                                },
                            4:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                },
                                5:{style:{
                                    Interior:{ 
                                        Color:"#95a5a6",
                                        Pattern:"Solid"
                                            },
                                    Alignment:{
                                        Horizontal: 'Center', 
                                        Vertical: 'Center',
                                        WrapText: 1, 
                                            },
                                    Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },                           
                                        }
                                    },
                        }   
                  },
            };
            this.showExportButton = true;
            alasql.promise('SELECT * INTO XLSXML("Trasvases_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
            .then(function(data){
                console.log('Data saved');
            }).catch(function(err){
                console.log('Error:', err);
            });
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/cashmovements/components/list-cash-movement/list-cash-movement.component.ts